import { Select } from "antd";
import React, { Component } from "react";
import axios from "axios";
import "../SearchForm/SearchForm.css";
import { Constant } from "../../config";

const { Option } = Select;

class RawDropdownCountry extends Component {
  state = {
    countryList: [],
  };

  async componentDidMount() {
    if (typeof this.props.onRef === "function") this.props.onRef(this);
    this.setState({
      countryList: await this._getCountryList(),
    });
  }

  _getCountryList = async () => {
    const opt = {
      url: `${Constant.COUNTRY_API}?limit=0`,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    let rtn = [{ region_code: "", name: "All Country" }];
    resp.data.data.map((v) => rtn.push(v));

    return rtn;
  };

  handleSubmit = (v) => {
    this.props.valueCallback(v);
  };

  render() {
    return (
      <Select
        showSearch
        placeholder="Country"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        style={{ width: "200px" }}
        onChange={(v) => this.handleSubmit(v)}
        value={this.props.value}
      >
        {(this.state.countryList || []).map((item, i) => (
          <Option key={i} value={item.region_code}>
            {item.name}
          </Option>
        ))}
      </Select>
    );
  }
}

export default RawDropdownCountry;



// WEBPACK FOOTER //
// ./src/containers/SearchForm/raw-dropdown-country.js